<template>
  <div
    class="task-evaluation"
    :style="data.paperType == '5' ? `height: ${96 - answerSheetVH}vh` : ''"
  >
    <div v-if="isStudent && data.answerDisplay != 1" class="answer-tip">
      {{ getAnswerDisplayTip() }}
    </div>

    <div
      v-if="!result.redoList || result.redoList.length < 2"
      class="score-cell"
    >
      <div class="label">总得分</div>
      <div class="score">
        <span :class="`text ${getScoreColor(data.score, data.totalScore)}`">
          {{ data.score }}{{ getScoreStatus() }}
        </span>
        <span class="total">/{{ data.totalScore }}</span>
      </div>
      <div
        v-if="!isStudent"
        class="label"
        style="color: #1890ff; z-index: 99"
        @click="getResource"
      >
        作答详情
      </div>
    </div>

    <div v-else class="row">
      <div class="col-49">
        <div class="score-cell">
          <div class="label" style="flex: 0 0 0.9rem">总分</div>
          <div class="score">
            <span :class="`text ${getScoreColor(data.score, data.totalScore)}`">
              {{ data.score }}{{ getScoreStatus() }}
            </span>
            <span class="total">/{{ data.totalScore }}</span>
          </div>
        </div>
        <div
          v-if="!isStudent"
          class="label"
          style="color: #1890ff; z-index: 99"
          @click="getResource"
        >
          作答详情
        </div>
      </div>
      <div class="col-49">
        <div class="score-cell">
          <div class="label">平均分</div>
          <div class="score">
            <span
              :class="`text ${getScoreColor(
                result.averageScore,
                data.totalScore
              )}`"
            >
              {{ result.averageScore }}
            </span>
            <span class="total">/{{ data.totalScore }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="redo-cell" v-if="result.redoList && result.redoList.length > 1">
      <div class="redo-cell-header row">
        <div class="col-40">完成时间</div>
        <div class="col-30">完成用时</div>
        <div class="col-30">成绩（{{ data.totalScore }}）</div>
      </div>
      <div
        v-for="item in result.redoList"
        :key="item.id"
        :class="`redo-cell-item row ${
          item.id == data.id ? 'redo-bold-row' : ''
        }`"
        @click="toTask(item)"
      >
        <div class="col-40">{{ item.completeTime }}</div>
        <div class="col-30">
          {{ item.duringTime > 0 ? item.duringTime : "<1" }}分钟
        </div>
        <div
          :class="`col-30 redo-cell-score ${getScoreColor(
            item.score,
            data.totalScore
          )}`"
        >
          {{ item.score }}
        </div>
        <van-icon class="arrow-right" name="arrow" v-if="item.id != data.id" />
      </div>
    </div>

    <div class="comment-cell" v-if="result.comment">
      <div class="comment-title">评语</div>
      <div class="comment-content">{{ result.comment }}</div>
    </div>

    <div
      :class="`evaluation-detail ${data.paperType == '5' ? 'pb1' : ''}`"
      id="evaluation-detail"
    >
      <div v-html="data.content" class="data-content"></div>
      <AnswerSheet
        :showBtn="false"
        v-if="data.paperType == '5'"
        :answerSheetVH="answerSheetVH"
        :data="data"
      />
    </div>
  </div>
</template>

<script>
import insert from "../util/insertDOM";
import { mapQuery } from "../util/URLUtils";
import AnswerSheet from "../components/AnswerSheet";
import { ImagePreview } from "vant";

export default {
  components: {
    AnswerSheet,
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    result: {
      type: Object,
      default: () => ({}),
    },
    isStudent: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      answerSheetVH: 50,
      currentPlayingAudio: null,
    };
  },

  beforeDestroy() {
    this.cleanupAudio();
  },

  mounted() {
    this.$nextTick(() => {
      this.initAudioControls();
      this.initImagePreview();
      this.renderAnswers();
    });
  },

  methods: {
    // 获取答案显示提示文本
    getAnswerDisplayTip() {
      const tips = {
        3: `当前作业为"仅显示对错"模式，仅显示对错，不显示正确答案`,
        2: `当前作业为"答案关"模式，不显示正确答案`,
        0: `当前作业为"作答达标显示答案"模式，未达标不显示正确答案`,
      };
      return tips[this.data.answerDisplay] || "";
    },

    // 获取得分状态
    getScoreStatus() {
      if (this.data.answerDisplay !== 0) return "";
      return this.data.score == 0
        ? ""
        : this.data.score >= this.data.scoreForAnswer
        ? "（达标）"
        : "（未达标）";
    },

    // 清理音频资源
    cleanupAudio() {
      if (this.currentPlayingAudio) {
        this.currentPlayingAudio.pause();
        this.currentPlayingAudio = null;
      }

      const audioList = document.querySelectorAll("audio");
      audioList.forEach((audio) => {
        const newAudio = audio.cloneNode(true);
        audio.parentNode?.replaceChild(newAudio, audio);
      });
    },

    // 初始化音频控制
    initAudioControls() {
      const audioList = document.querySelectorAll("audio");
      if (!audioList.length) return;

      audioList.forEach((audio) => {
        audio.addEventListener("play", () => this.handleAudioPlay(audio));
        audio.addEventListener("pause", () => this.handleAudioStop(audio));
        audio.addEventListener("ended", () => this.handleAudioStop(audio));
      });

      // 添加听力原文
      if (this.data.listeningText && this.data.showListening === 1) {
        const parent = audioList[0].parentNode;
        const newNode = document.createElement("p");
        newNode.innerHTML = `听力原文：${this.data.listeningText}`;
        parent?.after(newNode);
      }
    },

    // 处理音频播放
    handleAudioPlay(currentAudio) {
      if (
        this.currentPlayingAudio &&
        this.currentPlayingAudio !== currentAudio
      ) {
        this.currentPlayingAudio.pause();
      }

      document.querySelectorAll("audio").forEach((audio) => {
        if (audio !== currentAudio && !audio.paused) {
          audio.pause();
        }
      });

      this.currentPlayingAudio = currentAudio;
    },

    // 处理音频停止
    handleAudioStop(audio) {
      if (this.currentPlayingAudio === audio) {
        this.currentPlayingAudio = null;
      }
    },

    // 初始化图片预览
    initImagePreview() {
      const imgDomList = document.querySelectorAll("#evaluation-detail img");
      imgDomList.forEach((img) => {
        img.addEventListener("click", (e) => {
          ImagePreview({
            images: [e.target.src],
            closeable: true,
          });
        });
      });
    },

    // 渲染答案
    renderAnswers() {
      if (!this.result.subResults) return;

      this.result.subResults.forEach((item) => {
        const domList = document.querySelectorAll(`[name="${item.tagId}"]`);
        if (!domList.length) return;

        if (domList.length > 1) {
          this.renderMultipleChoice(item, domList);
        } else if (item.tagId.includes("text")) {
          this.renderFillInBlank(item, domList[0]);
        } else if (item.tagId.includes("area")) {
          this.renderEssay(item, domList[0]);
        }
      });
    },

    // 判断是否应显示对错标记和颜色（未达标练习模式下不显示）
    shouldShowCorrection(item) {
      if (
        this.data.practiceMode == 1 &&
        this.data.answerDisplay == 0 &&
        this.data.userType == 3 &&
        this.data.score < this.data.scoreForAnswer
      ) {
        return false;
      }
      // answerDisplay==3 仅显示对错，有 standardAnswer 也显示
      return item.answerDisplay == 3 || !!item.standardAnswer;
    },

    // 渲染选择题
    renderMultipleChoice(item, domList) {
      domList.forEach((tag) => {
        const parent = tag.parentNode;
        if (!parent) return;

        if (item.answer && item.answer.indexOf(tag.value) > -1) {
          tag.checked = true;

          if (this.shouldShowCorrection(item)) {
            parent.className +=
              item.subScore === item.subTotalScore ? " green" : " red";
            const tagNode = this.createMarkNode(
              item.subScore === item.subTotalScore ? "√" : "×",
              item.subScore === item.subTotalScore ? "green" : "red"
            );
            parent.appendChild(tagNode);
          }
        }

        if (
          this.shouldShowCorrection(item) &&
          tag.value == item.standardAnswer &&
          item.answer != item.standardAnswer
        ) {
          parent.className += " green";
        }

        if (item.remark) {
          const remarkNode = document.createElement("span");
          remarkNode.className = "green";
          remarkNode.innerHTML = `（注释：${item.remark}）`;
          parent.appendChild(remarkNode);
        }
      });
    },

    // 渲染填空题
    renderFillInBlank(item, tag) {
      const parent = tag.parentNode;
      if (!parent) return;

      tag.value = item.answer || "";
      tag.style.width = this.calculateInputWidth(item.answer);

      const showCorrection = this.shouldShowCorrection(item);

      if (showCorrection) {
        tag.className += item.subScore ? " green" : " red";
      }

      if (item.remark) {
        const remarkNode = document.createElement("span");
        remarkNode.className = "green";
        remarkNode.innerHTML = `注释：${item.remark}`;
        parent.insertBefore(remarkNode, tag.nextSibling);
      }

      if (
        showCorrection &&
        item.standardAnswer &&
        item.subScore != item.subTotalScore
      ) {
        const answerNode = document.createElement("span");
        answerNode.className = "green";
        answerNode.innerHTML = `(答案：${item.standardAnswer})`;
        parent.insertBefore(answerNode, tag.nextSibling);
      }

      if (
        showCorrection &&
        (item.answer || item.answerDisplay == 3 || item.standardAnswer)
      ) {
        const resultNode = this.createFillInBlankResult(item);
        parent.replaceChild(resultNode, tag);

        if (item.answerDisplay != 3) {
          this.renderAISuggestion(item, parent);
        }
      }
    },

    // 创建填空题结果节点（使用 span 行内插入，避免 div+translateY 在段落中与 Word 样式叠字）
    createFillInBlankResult(item) {
      const tagNode = document.createElement("span");
      tagNode.className = "fill-blank-result";

      if (item.subScore === item.subTotalScore) {
        tagNode.classList.add("green");
        if (item.answerDisplay == 3) {
          tagNode.innerHTML = `√`;
        } else {
          tagNode.innerHTML = `<span class="fill-blank-answer">${item.answer}</span><span class="fill-blank-mark">√</span>`;
        }
      } else if (item.subScore > 0 && item.subScore < item.subTotalScore) {
        tagNode.classList.add("orange");
        tagNode.innerHTML = item.answer
          ? `<span class="fill-blank-answer">${item.answer}</span><span class="fill-blank-mark">⍻</span>`
          : `<span class="fill-blank-mark">⍻</span>`;
      } else {
        tagNode.classList.add("red");
        tagNode.innerHTML = item.answer
          ? `<span class="fill-blank-answer">${item.answer}</span><span class="fill-blank-mark">×</span>`
          : `<span class="fill-blank-mark">×</span>`;
      }

      return tagNode;
    },

    // 渲染智能优化建议
    renderAISuggestion(item, parent) {
      const aiCorrect = this.result.aiCorrectList?.find(
        (ai) => ai.answerId === item.id
      );

      if (!aiCorrect) return;

      const aiSuggestionNode = document.createElement("div");
      aiSuggestionNode.className = "ai-suggestion-container";
      aiSuggestionNode.style.cssText = `
        margin-top: 10px;
        padding: 12px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
      `;

      const titleNode = document.createElement("div");
      titleNode.style.cssText = `
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 8px;
      `;
      titleNode.innerHTML = `<span style="margin-right: 6px;">🤖</span><span>智能优化建议</span>`;

      const contentNode = document.createElement("div");
      contentNode.style.cssText = `
        background: #fff;
        padding: 10px;
        border-radius: 6px;
        color: #333;
        font-size: 13px;
        line-height: 1.6;
      `;

      if (aiCorrect.content) {
        contentNode.appendChild(
          this.createAISection("回答内容", aiCorrect.content, "#3b82f6")
        );
      }

      const evaluations = [
        {
          message: aiCorrect.evaluateOneMessage,
          score: aiCorrect.evaluateOneScore,
          title: "内容完整性",
        },
        {
          message: aiCorrect.evaluateTwoMessage,
          score: aiCorrect.evaluateTwoScore,
          title: "语言准确性",
        },
        {
          message: aiCorrect.evaluateThreeMessage,
          score: aiCorrect.evaluateThreeScore,
          title: "逻辑连贯性",
        },
      ];

      evaluations.forEach(({ message, score, title }) => {
        if (message) {
          contentNode.appendChild(
            this.createAIEvaluation(title, message, score)
          );
        }
      });

      aiSuggestionNode.appendChild(titleNode);
      aiSuggestionNode.appendChild(contentNode);
      parent.appendChild(aiSuggestionNode);
    },

    // 创建AI内容区块
    createAISection(title, content, borderColor) {
      const section = document.createElement("div");
      section.style.cssText = `
        margin-bottom: 10px;
        padding: 8px;
        background: #f0f9ff;
        border-left: 3px solid ${borderColor};
        border-radius: 4px;
      `;
      section.innerHTML = `
        <div style="color: #1e40af; font-weight: 600; margin-bottom: 4px;">${title}：</div>
        <div style="color: #1e3a8a;">${content}</div>
      `;
      return section;
    },

    // 创建AI评估项
    createAIEvaluation(title, message, score) {
      const item = document.createElement("div");
      const isGood = score !== 0;
      item.style.cssText = `
        margin-bottom: 8px;
        padding: 8px;
        background: ${isGood ? "#f0fdf4" : "#fef2f2"};
        border-left: 3px solid ${isGood ? "#22c55e" : "#ef4444"};
        border-radius: 4px;
      `;
      item.innerHTML = `
        <div style="margin-bottom: 4px;">
          <span style="color: ${
            isGood ? "#16a34a" : "#dc2626"
          }; font-weight: 600;">
            ${title}：
          </span>
        </div>
        <div style="color: #374151;">${message}</div>
      `;
      return item;
    },

    // 渲染作文题
    renderEssay(item, tag) {
      const parent = tag.parentNode;
      if (!parent || !item.correctData?.sentenceComments) return;

      tag.className += " dn";

      const answer = this.processEssayAnswer(item);
      const newNode = this.createEssayNode(item, answer);

      if (this.shouldShowCorrection(item)) {
        const tagNode = this.createMarkNode(
          item.subScore === item.subTotalScore ? "√" : "×",
          item.subScore === item.subTotalScore ? "green" : "red"
        );
        parent.replaceChild(tagNode, tag);
      } else {
        parent.append(newNode);
      }
    },

    // 处理作文答案
    processEssayAnswer(item) {
      let answer = item.answer;
      const sentenceComments = item.correctData.sentenceComments;

      sentenceComments.forEach((comment) => {
        let sentence = comment.sentence.sentence;
        const sentenceArr = sentence.split(" ");
        const deletedErrorArr = sentenceArr.slice();

        comment.suggestions.forEach((sug) => {
          const [error0, error1] = sug.errorPosition;
          const errorArr = sentenceArr.slice(error0, error1 + 1);
          deletedErrorArr.splice(error0, error1 - error0 + 1);

          const hintText = this.createHintText(errorArr, sug);
          deletedErrorArr.splice(error0, 0, hintText);

          if (error1 - error0 > 0) {
            for (let k = 0; k < error1 - error0; k++) {
              deletedErrorArr.splice(error0, 0, "");
            }
          }

          const newSentence = deletedErrorArr.join(" ");
          answer = answer.replace(sentence, newSentence);
          sentence = newSentence;
        });
      });

      return answer;
    },

    // 创建提示文本
    createHintText(errorArr, sug) {
      if (sug.origin) {
        return `${errorArr
          .join(" ")
          .replace(
            sug.origin,
            `<span class="red">${sug.origin}`
          )}</span><span style="font-weight: bold">（${sug.message}）</span>`;
      }

      if (errorArr.length == 2) {
        return `${errorArr[0]}<span style="font-weight: bold">（${sug.message}）</span>${errorArr[1]}`;
      }

      return `<span class="red">${errorArr.join(
        " "
      )}</span><span style="font-weight: bold">（${sug.message}）</span>`;
    },

    // 创建作文节点
    createEssayNode(item, answer) {
      const newNode = document.createElement("div");
      newNode.className = "evaluation-area";

      const content = document.createElement("div");
      content.className = "area-content";
      content.innerHTML = answer;

      const holder2 = document.createElement("div");
      holder2.className = "holder2";
      content.append(holder2);

      const scoreCat = item.correctData.scoreCat;
      content.append(
        insert.scoreCell({
          score: [item.subScore],
          total: [item.subTotalScore],
          count: 1,
          label: ["单题总分"],
        })
      );

      content.append(
        insert.scoreCell({
          score: [scoreCat.content.score, scoreCat.sentences.score],
          total: [100, 100],
          count: 2,
          label: [scoreCat.content.name, scoreCat.sentences.name],
        })
      );

      content.append(
        insert.scoreCell({
          score: [scoreCat.structure.score, scoreCat.words.score],
          total: [100, 100],
          count: 2,
          label: [scoreCat.structure.name, scoreCat.words.name],
        })
      );

      content.append(
        insert.evaluationCell({
          comment: item.correctData.comment,
        })
      );

      const etitle = document.createElement("div");
      etitle.className = "etitle";
      etitle.innerHTML = "作文批改分析：";

      newNode.append(etitle, content);
      return newNode;
    },

    // 创建标记节点
    createMarkNode(text, className) {
      const node = document.createElement("span");
      node.className = className;
      node.innerHTML = text;
      node.style.fontSize = "20px";
      node.style.transform = "translateY(5px)";
      node.style.display = "inline-block";
      return node;
    },

    // 计算输入框宽度
    calculateInputWidth(answer) {
      if (!answer) return "100px";
      const answerList = answer.split(" ");
      return answerList.length > 2 ? `${answerList.length * 50}px` : "100px";
    },

    getScoreColor(score, total) {
      return insert.getScoreColor(score, total);
    },

    getResource() {
      let duringTime = 0;
      if (this.result.redoList?.length > 0) {
        const current = this.result.redoList.find(
          (r) => r.id === this.result.id
        );
        duringTime = current?.duringTime || 0;
      }

      wx.miniProgram.redirectTo({
        url: `/pages/student-task-detail/index?userTaskId=${this.result.id}&duringTime=${duringTime}`,
      });
    },

    toTask(item) {
      if (item.id != this.data.id) {
        const query = {
          ...mapQuery(),
          id: item.id,
        };
        this.$router.replace({ path: "/pen", query });
      }
    },
  },
};
</script>

<style lang="less">
.task-evaluation {
  padding-top: 0.4rem;
  overflow-y: auto;

  .evaluation-detail {
    font-family: "Times New Roman";
    font-size: 12pt;
    line-height: 1.6em;
  }

  /* v-html / Word 导出：段内 .green 曾用 div+inline-block+translateY，易与前后文水平重叠 */
  .data-content {
    .fill-blank-result {
      display: inline;
      vertical-align: baseline;
      white-space: normal;
      font-size: 1.15em;
      line-height: inherit;
    }

    .fill-blank-answer {
      text-decoration: underline;
      text-underline-offset: 2px;
      padding: 0 2px;
      box-decoration-break: clone;
      -webkit-box-decoration-break: clone;
    }

    .fill-blank-mark {
      display: inline;
      vertical-align: baseline;
      margin-left: 1px;
    }

    div.green {
      display: inline !important;
      transform: none !important;
      vertical-align: baseline;
      margin: 0;
      padding: 0;
      white-space: normal;
    }

    div.green > span[style*="text-decoration"],
    div.green > span[style*="underline"] {
      padding: 0 3px !important;
      vertical-align: baseline;
      box-decoration-break: clone;
      -webkit-box-decoration-break: clone;
    }
  }

  input[type="radio"],
  input[type="text"],
  textarea {
    pointer-events: none;
  }
}

.answer-tip {
  padding: 10px 20px 0;
  color: red;
  font-size: 12px;
}

p {
  margin: 10px 0 !important;
}
</style>
